import styled from 'styled-components';

export const Wrapper = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: flex-end;
	width: 100%;
	height: 100%;
	font-family: Lato;
	font-size: 14px;
	padding-right: 10px;
	box-sizing: border-box;
	margin: 10px 0;
	color: #7f7c85;
`;

export const ToggleButton = styled.div`
	cursor: pointer;
	display: flex;
	align-items: flex-end;
	justify-content: center;
	gap: 10px;
`;

export const LightbulbIconImage = styled.img`
	width: 20px;
	margin-bottom: 5px;
`;

export const Bubble = styled.div`
	background: #eef2f5;
	border-radius: 10px;
	padding: 10px;
	margin: 5px 0;
	max-width: 60%;
	border: 1px solid #cfcfcf;

	@media (min-width: 768px) {
		max-width: 300px;
	}
`;

export const Spacer = styled.div`
	width: 100%;
	height: 1px;
	background-color: #cfcfcf;
	margin: 5px 0;
`;

export const Text = styled.div`
	text-align: left;
`;

export const Title = styled.div`
	font-weight: 700;
	text-align: left;
	letter-spacing: 0.5px;
	margin-bottom: 5px;
`;

export const BottomBar = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	width: 100%;
  margin-top: 10px;
`;

export const BottomIcon = styled.img`
  cursor: pointer;
	width: 16px;
`;
